'use client';

import { ReactNode } from 'react';
import * as styles from './order-complete-layout.css';

interface OrderCompleteLayoutProps {
  hero: ReactNode;
  children: ReactNode;
}

/**
 * Shared chrome for the three order-complete screens: hero on top, body below.
 * Body content is left to each state component (which often uses `useMediaQuery`
 * to switch between a stacked mobile layout and a two-column desktop layout).
 */
export const OrderCompleteLayout = ({ hero, children }: OrderCompleteLayoutProps) => (
  <div className={styles.wrapper}>
    {hero}
    {children}
  </div>
);

export const OrderCompleteStack = ({ children }: { children: ReactNode }) => (
  <div className={styles.singleColumn}>{children}</div>
);

interface TwoColumnProps {
  left: ReactNode;
  right: ReactNode;
}

/**
 * Desktop-only two-column layout. On mobile, falls back to a vertical stack
 * (left column first). State components that need a different mobile order
 * (e.g. Pickup mobile shows the restaurant card before the map) should compose
 * their own structure instead of using this helper.
 */
export const OrderCompleteTwoColumn = ({ left, right }: TwoColumnProps) => (
  <div className={styles.twoColumn}>
    <div className={styles.column}>{left}</div>
    <div className={styles.column}>{right}</div>
  </div>
);
